import React, { lazy } from "react";
import "antd/dist/antd.min.css";
import "./index.scss";
import { Layout } from "antd";
const HeaderComponent = lazy(() => import("./header/HeaderComponent"));
const AppContent = lazy(() => import("./content/AppContent"));
const FooterComponent = lazy(() => import("./footer/FooterComponent"));
const Sidebar = lazy(() => import("./sidebar/Sidebar"));
const { Header, Content, Footer } = Layout;

const AppLayout = (props) => {
  return (
    <Layout
      style={{
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Sidebar />
      <Layout className="site-layout">
        <Header
          theme="light"
          className="header"
          style={{
            padding: 0,
          }}
        >
          <HeaderComponent />
        </Header>
        <Content>
          <AppContent />
        </Content>
        <Footer
          style={{
            textAlign: "center",
          }}
        >
          <FooterComponent />
        </Footer>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
